import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import PropTypes from 'prop-types'

class Tabs extends Component {
  constructor () {
    super()
    this.tabRefs = []
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.currentIndex !== undefined) {
      this.selectTab(nextProps.currentIndex)
    }
  }

  componentDidMount () {
    const { currentIndex } = this.props
    this.slideRef.style.left = `${this.tabRefs[currentIndex].ref.offsetLeft}px`
    this.slideRef.style.width = `${this.tabRefs[currentIndex].ref.offsetWidth}px`
  }

  selectTab = (selectedIndex) => {
    const selected = this.tabRefs.find(tab => tab.index === selectedIndex)
    this.slideRef.style.left = `${selected.ref.offsetLeft}px`
    this.slideRef.style.width = `${selected.ref.offsetWidth}px`
  }

  getSlide = (ref) => {
    this.slideRef = ReactDOM.findDOMNode(ref)
  }

  render () {
    return (
      <Container>
        <Flexer>
          {this.props.tabs.map((tab, index) => (
            <Tab
              className={this.props.currentIndex === index && 'selected'}
              key={tab} onClick={() => this.props.onClick(index)}
              ref={(ref) => this.tabRefs.push({ index, ref: ReactDOM.findDOMNode(ref) })}
              progress={this.props.hasProgress ? index < this.props.currentIndex : false}
            >{tab}</Tab>
          ))}
        </Flexer>
        <Slide ref={this.getSlide} />
        <Underline />
      </Container>
    )
  }
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string)
}

const Container = styled.div`
  width: 100%;
  height: 60px;
  position: relative;


`

const Flexer = styled.div`
  display: flex;
  justify-content: space-around;
  height: 100%;
  align-items: center;
`

const Tab = styled.div`
  height: 36px;
  flex: 1;
  color: #9C9C9C;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  cursor: pointer;

  ${({ progress }) => progress && `
    color: #3E3E3E;
    font-weight: bold;
  `}

  &.selected {
    color: #3E3E3E;
    font-weight: bold;
  }

  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`

const Slide = styled.span`
  height: 5px;
  width: 120px;
  background: linear-gradient(270deg, #006736 0%, #93C13E 100%);
  display: inline-block;
  position: absolute;
  bottom: 0;

  transition: 0.3s ease-in-out;
`

const Underline = styled.span`
  height: 1px;
  width: 100%;
  background: linear-gradient(270deg, #006736 0%, #93C13E 100%);
  position: absolute;
  bottom: 0;
  left: 0;
`

export default Tabs



// WEBPACK FOOTER //
// ./src/components/Tabs/index.js